// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"cb_a bhf_h bhf_kf bhf_wb bhf_ss bhf_vr bhf_su bhf_sl"};